import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { completeLineLogin } from './utils/LineLoginActions';

const LineLoginComplete = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const state = searchParams.get('state');

  useEffect(() => {
    if (!code || !state) return;

    const completeLogin = async () => {
      try {
        const result = await completeLineLogin(code, state);
        if (!result.success) {
          alert(result.message);
        }

        if (result.data.redirect_url) {
          window.location.href = result.data.redirect_url;
        }
      } catch (err) {
        console.error(err);
        alert(`error occurred while completing login: ${err.message}`);
      }
    };

    completeLogin();
  }, [code, state]);

  return (
    <div>
      <h1>Line Login Complete</h1>
      <p>Completing</p>
    </div>
  );
};

export default LineLoginComplete;
